
<div class="report-img-container">
    <div class="container-data">
        <div>
            <div class="image-name"><strong>{{"ocr-container-comany-code" | translate}}</strong></div>
            <div class="image-name"><strong>{{"ocr-container-number" | translate}}</strong></div>
            <div class="image-name"><strong>{{"ocr-container-type" | translate}}</strong></div>
            <div class="image-name"><strong>{{"ocr-container-check-digit" | translate}}</strong></div>
            <div class="image-name"><strong>{{"ocr-container-valid" | translate}}</strong></div>
        </div>
        <div>
            <div class="image-name">{{container.CompanyCode}} </div>
            <div class="image-name">{{container.ContainerNumber}} </div>
            <div class="image-name">{{container.ContainerType}} </div>
            <div class="image-name">{{container.CheckDigit}} </div>
            <div class="image-name">{{container.IsValid}} </div>
        </div>
    </div>
    <div class="report-image-list">
            <img class="report-image" src='{{container.PhotoFileName}}' (click)="openImage(container.PhotoFileName)" />
    </div>
</div>
